import { CREATE_ADIB_CLIENT, CREATE_ADIB_CLIENT_SUCCESS, CREATE_ADIB_CLIENT_ERROR, CREATE_ADIB_CLIENT_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateAdibClient = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ADIB_CLIENT:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_ADIB_CLIENT_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_ADIB_CLIENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_ADIB_CLIENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateAdibClient;
